<template>
  <div>
    <v-progress-circular indeterminate v-if="loadingUser"></v-progress-circular>
    <DisplayTable
      v-if="!loadingUser"
      v-bind:data="user"
      v-bind:columns="userColumns"
      v-bind:tableTitle="'User'"
    ></DisplayTable>
    <UserRoleButtons
      v-if="!loadingUser"
      v-bind:userId="user[0]['userId']"
      v-bind:factoryWorker="user[0]['factoryWorker']"
      v-bind:superAdmin="user[0]['superAdmin']"
    ></UserRoleButtons>
    <br />

    <v-progress-circular indeterminate v-if="loadingHomes"></v-progress-circular>
    <DisplayTable
      v-if="!loadingHomes"
      v-bind:data="homes"
      v-bind:columns="homeColumns"
      v-bind:routerLinkPath="'home'"
      v-bind:routerLinkKey="'homeId'"
      v-bind:tableTitle="'Homes'"
    ></DisplayTable>
    <br />
    <v-progress-circular indeterminate v-if="loadingDevices"></v-progress-circular>
    <DisplayTable
      v-if="!loadingDevices"
      v-bind:data="devices"
      v-bind:columns="deviceColumns"
      v-bind:routerLinkPath="'device'"
      v-bind:routerLinkKey="'deviceId'"
      v-bind:tableTitle="'Devices'"
    ></DisplayTable>

    <br />
    <router-link :to="'/'">Go back to search page</router-link>
  </div>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default
import DisplayTable from "@/views/DisplayTable"
import UserRoleButtons from "@/views/UserRoleButtons"

export default {
  components: {
    DisplayTable,
    UserRoleButtons
  },
  data() {
    return {
      userId: "",
      user: [],
      userColumns: [],
      homes: [],
      homeColumns: [],
      devices: [],
      deviceColumns: [],
      loadingUser: false,
      loadingHomes: false,
      loadingDevices: false
    }
  },
  async mounted() {
    middleware.run(this.$router)
    await this.init()
  },
  methods: {
    async init() {
      this.loadingUser = true
      this.loadingHomes = true
      this.loadingDevices = true

      try {
        this.userId = this.$route.params.id
        var userResult = await restHelper.getUser(this.userId)
        this.loadingUser = false
        this.user = [userResult.data]
        this.userColumns = [
          "userId",
          "email",
          "firstName",
          "lastName",
          "connections"
        ]
        var homeResult = await restHelper.getHomesForUser(this.userId)
        this.loadingHomes = false
        this.homes = homeResult.data.homes
        this.homeColumns = ["homeId", "homeName", "isAdmin"]
        var deviceResult = await restHelper.getDevicesForUser(this.userId)
        this.loadingDevices = false
        this.devices = deviceResult.data.devices
        this.deviceColumns = ["deviceId", "homeId", "alias", "isAdmin"]
      } catch (error) {}

      this.loadingUser = false
      this.loadingHomes = false
      this.loadingDevices = false
    }
  }
}
</script>

